module.exports = __webpack_public_path__ + "static/media/limpeza.4a5dec6e.svg";